import React from "react";

/* Бегущая лента с повторяющимся "ЩЁТКА" — отсылка к лицевой стороне визитки. */
export const Marquee = ({ text = "ЩЁТКА", className = "" }) => {
  const items = Array.from({ length: 12 }, (_, i) => i);
  return (
    <div
      className={`overflow-hidden whitespace-nowrap select-none ${className}`}
      data-testid="brand-marquee"
      aria-hidden="true"
    >
      <div className="flex animate-marquee will-change-transform">
        {[0, 1].map((dup) => (
          <div className="flex shrink-0" key={dup}>
            {items.map((i) => (
              <span
                key={`${dup}-${i}`}
                className="font-heading text-[14vw] md:text-[9vw] leading-none px-6 text-burgundy/30"
              >
                {text}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
